export default __webpack_public_path__ + "static/media/NIAS0560.34I-40206_-23874_0.61508045.jpg";